
export const convStlmDateString = (dateStr) => {
    // if (dateStr.length !== 14) {
    //     return "유효하지 않은 길이의 문자열입니다.";
    // }

    const year = dateStr.slice(0, 4);      // 2025
    const month = dateStr.slice(4, 6);     // 01
    const day = dateStr.slice(6, 8);       // 01
    const hour = dateStr.slice(8, 10);      // 01
    const minute = dateStr.slice(10, 12);   // 01
    const second = dateStr.slice(12, 14);   // 00

    // 원하는 형식으로 문자열을 조합합니다.
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}